module.exports={
     // BASE_API:'http://localhost:8000/api/',
     // BASE_URL:'http://192.168.1.106:8000/'
     BASE_API:'https://staff.goldfruit.vn/api/',
     BASE_URL:'https://staff.goldfruit.vn/'
}